import React, { useState } from 'react';
import axios from '../config/axios';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  Box,
  CircularProgress
} from '@mui/material';
import { useTheme } from '../context/ThemeContext';

function ProcessClientDialog({ open, contractId, onClose, contract }) {
  const { themeColors } = useTheme();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [confirmed, setConfirmed] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  // Cargar imagen original (id_imagenID)
  const loadOriginalImage = async () => {
    try {
      const response = await axios.get(
        `/api/contracts/${contractId}/identification/image`,
        { responseType: 'blob' }
      );
      const url = URL.createObjectURL(response.data);
      setImageUrl(url);
    } catch (err) {
      console.error('Error al cargar imagen:', err);
      setError('Error al cargar la imagen');
    }
  };

  const handleConfirmReceived = async () => {
    try {
      setLoading(true);
      setError(null);
      console.log('1. Iniciando confirmación...');

      // Confirmar recepción
      await axios.post(
        `/api/contracts/${contractId}/identification/confirm-received`
      );
      console.log('2. Recepción confirmada');

      // Cargar la imagen para mostrar
      await loadOriginalImage();
      console.log('3. Imagen cargada');

      setConfirmed(true);
      console.log('4. Estado confirmed:', true);

    } catch (err) {
      console.error('Error:', err);
      setError(err.response?.data?.error || 'Error al procesar la imagen');
    } finally {
      setLoading(false);
    }
  };

  // Subir imagen recibida (id_imagenID_recibido)
  const handleUploadReceivedImage = async () => {
    if (!selectedFile) {
      setError('Por favor seleccione una imagen');
      return;
    }

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('id_imagenID_recibido', selectedFile);

      await axios.post(
        `/api/contracts/${contractId}/identification/upload-received`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      onClose(true);
    } catch (err) {
      console.error('Error:', err);
      setError('Error al subir la imagen recibida');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => onClose()} maxWidth="sm" fullWidth>
      <DialogTitle>
        Proceso con Cliente 
        <Typography variant="caption" color="textSecondary">
          (Confirmed: {confirmed ? 'Sí' : 'No'})
        </Typography>
      </DialogTitle>
      <DialogContent>
        {error && (
          <Typography color="error" gutterBottom align="center">
            {error}
          </Typography>
        )}

        {loading ? (
          <Box textAlign="center" my={4}>
            <CircularProgress />
          </Box>
        ) : !confirmed ? (
          <Box textAlign="center" my={4}>
            <Typography gutterBottom>
              Debug: Estado actual - No confirmado
            </Typography>
            <Button
              variant="contained"
              onClick={handleConfirmReceived}
              sx={{ backgroundColor: themeColors.primary }}
            >
              Confirmar Recepción
            </Button>
          </Box>
        ) : (
          <Box textAlign="center" my={4}>
            <Typography gutterBottom>
              Debug: Estado actual - Confirmado
            </Typography>
            <Typography gutterBottom>
              Imagen enviada al cliente:
            </Typography>
            {imageUrl && (
              <img src={imageUrl} alt="Identificación" style={{ maxWidth: '100%' }} />
            )}

            <Box mt={3}>
              <Typography variant="h6" gutterBottom color="primary">
                Subir imagen recibida del cliente
              </Typography>
              <input
                accept="image/*"
                type="file"
                onChange={(e) => {
                  console.log('Archivo seleccionado:', e.target.files?.[0]);
                  setSelectedFile(e.target.files?.[0]);
                }}
                style={{ display: 'none' }}
                id="received-image-input"
              />
              <label htmlFor="received-image-input">
                <Button 
                  variant="contained"
                  component="span"
                  sx={{ 
                    backgroundColor: themeColors.primary,
                    '&:hover': { backgroundColor: themeColors.secondary }
                  }}
                >
                  Seleccionar Imagen
                </Button>
              </label>
              {selectedFile && (
                <Box mt={2}>
                  <Typography variant="body2">
                    Archivo seleccionado: {selectedFile.name}
                  </Typography>
                  <Button
                    variant="contained"
                    onClick={handleUploadReceivedImage}
                    sx={{ 
                      mt: 2,
                      backgroundColor: themeColors.primary,
                      '&:hover': { backgroundColor: themeColors.secondary }
                    }}
                  >
                    Subir Imagen
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default ProcessClientDialog; 